function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.333 3A3.341 3.341 0 0 0 3 6.333v17.334A3.341 3.341 0 0 0 6.333 27h17.334A3.341 3.341 0 0 0 27 23.667V6.333A3.341 3.341 0 0 0 23.667 3zm15.334 2.667A2.667 2.667 0 1 1 19 8.333a2.677 2.677 0 0 1 2.667-2.666zM12.7 11a1.349 1.349 0 0 1 1.161.63l2.6 4.221 1.023-1.557a1.4 1.4 0 0 1 1.161-.628 1.4 1.4 0 0 1 1.167.628l4.3 6.56A1.407 1.407 0 0 1 22.961 23H7.068a1.433 1.433 0 0 1-1.2-2.151l5.672-9.219A1.349 1.349 0 0 1 12.7 11z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#b2b2b2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.7d646e2c9f1c626b0d2a2edf6e251999.svg";
export { ForwardRef as ReactComponent };